import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../../../store/reducers/store';
import { useTranslation } from 'react-i18next';

const InvestorsArray: React.FC = () => {
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t, i18n } = useTranslation();
    
    if (portfolio === undefined){
        return <></>;
    }

    const sortedInvestors = [...portfolio.investors]
    sortedInvestors.sort((a, b) => b.amount - a.amount);

    return <TableContainer>
    <Table sx={{ minWidth: 200 }} aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell>#</TableCell>
          <TableCell>{t('PortfolioDetailsInvestorsInvestorName')}</TableCell>
          <TableCell>{t('PortfolioDetailsInvestorsAmount')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
          {sortedInvestors.slice(0,5).map((inv, i) => <TableRow key={inv.id}>
              <TableCell>{i+1}.</TableCell>
              <TableCell>{inv.name} {inv.surname}</TableCell>
              <TableCell>€{Math.round(inv.amount).toLocaleString(i18n.language)}</TableCell>
          </TableRow>)}
      </TableBody>
  </Table>
  </TableContainer>
}

export default InvestorsArray;